import 'zone.js/dist/zone'; // Included with Angular CLI.
//import 'web-animations-js';

/**
 * If you are supporting IE11 or legacy Edge, uncomment the following:
 */
// import 'core-js/es/array';
// import 'core-js/es/object';
// import 'core-js/es/promise';
// import 'core-js/es/string';

/**
 * Add global object polyfill for compatibility
 */
(window as any).global = window;